export default "__VITE_ASSET__Dj7iH$0O__"